import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetClaimTrackingStatusResponseDto } from "../../dtos/get-claim-tracking-status-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimStatusTrackingQueryParams = {
  queryParams: { claimId: string };
  options?: Omit<
    UseQueryOptions<GetClaimTrackingStatusResponseDto>,
    "queryKey"
  >;
};

export const useGetClaimStatusTrackingQuery = ({
  queryParams,
  options
}: UseGetClaimStatusTrackingQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getClaimStatusTracking(queryParams.claimId)
      .queryKey,
    queryFn: async () =>
      await OrderService.getClaimStatusTracking({ payload: queryParams }),
    ...options
  });
};
